import BackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';

export const BackButton = ({ onClick }: { onClick: () => void }) => (
  <IconButton data-testid="back-button" onClick={onClick} aria-label="Back">
    <BackIcon sx={theme => ({ color: theme.typography.body1.color })} />
  </IconButton>
);
